import styles from './WelcomeDemo.module.scss';
import { utility, Button, Modal } from '@phi/components';
import { defineComponent, h } from 'vue';
import { closing_welcome_window } from '@frontend/utility';

const a = (href: string, text: string) => `<a class='link' href='${href}' target='_blank'>${text}</a>`;

const footer = `By proceeding you agree to <br>
    our ${a('https://phi3d.com/terms-of-service', 'terms of service')}
    and our ${a('https://phi3d.com/privacy-policy', 'privacy policy')}.
`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Modal, {
            show: this.show,
            'onUpdate:show': () => this.$emit('update:show', false),
            id: 'tutorialsModalDemo',
        }, {
            body: () => h('div', { class: [utility.center, utility.margin_gap_5, utility.p_5 ] }, [
                h('h2', { class: [utility.huge] }, 'Welcome to Phi!'),
                h('p', 'This is a Guest session. Feel free to open a free account anytime, to save or export your work!'),
                h('div', { class: [ styles.actions, utility.m_auto ] }, h(Button, {
                    variant: 'primary',
                    onClick: () => closing_welcome_window(true),
                }, () => 'Start designing')),
                h('p', { class: [utility.light, utility.small, styles.footer ], innerHTML: footer }),
            ]),
        });
    }
});
